import { Errors, trackError } from "modules/monitoring";

import { Currency, CURRENCY_SYMBOL } from "../../constants";

// Get currency symbol using currency type
export const getCurrencySymbol = (currency?: string | null) => {
  switch (currency) {
    case Currency.JPY:
      return CURRENCY_SYMBOL.JPY;
    case Currency.USD:
      return CURRENCY_SYMBOL.USD;
    case null:
      return "$";
    default:
      trackError(`Unknown Currency: ${currency}`, {
        label: Errors.GET_CURRENCY_SYMBOL,
      });

      return undefined;
  }
};
